<template>
  <div class="place" @click.self="deselectActiveSlide">
    <main-content
      v-if="backgroundImage"
      :background-image="backgroundImage"
      right-sidebar="true"
    >
      <div class="place__tag-layer">
        <transition-group :css="false" @enter="enter" @afterEnter="afterEnter" @leave="leave">
          <template v-for="(tag, index) in filteredTags" tag="div">
            <tag-rich v-if="tag.type === 'rich'" :data-index="index" :key="`rich-${tag._id}`" v-bind="tag" :rtl="language.rtl" :lang="language.code" :active="tag._id === activeRichTagId" @click.native="setActiveRichTagId(tag._id)"></tag-rich>
            <tag-basic v-if="tag.type === 'basic'" :data-index="index" :key="`basic-${tag._id}`" v-bind="tag" :lang="language.code"></tag-basic>
            <tag-box v-if="tag.type === 'box'" :data-index="index" :key="`box-${tag._id}`" v-bind="tag" :lang="language.code"></tag-box>
            <tag-trail v-if="tag.type === 'trail'" :data-index="index" :key="`trail-${tag._id}`" v-bind="tag" :lang="language.code"></tag-trail>
          </template>
        </transition-group>

        <feature-tags
          v-if="featureTags.length"
          :tags="featureTags"
        />
      </div>

      <div v-if="activeInteractiveSlideTags" class="place__tag-layer">
        <transition-group :css="false" @enter="enter" @afterEnter="afterEnter" @leave="leave">
          <template v-for="(tag, index) in activeInteractiveSlideTags" tag="div">
            <tag-rich v-if="tag.type === 'rich'" :data-index="index" :key="`rich-${tag._id}`" v-bind="tag" :rtl="language.rtl" :lang="language.code" :active="tag._id === activeRichTagId" @click.native="setActiveRichTagId(tag._id)"></tag-rich>
            <tag-basic v-if="tag.type === 'basic'" :data-index="index" :key="`basic-${tag._id}`" v-bind="tag" :lang="language.code"></tag-basic>
            <tag-box v-if="tag.type === 'box'" :data-index="index" :key="`box-${tag._id}`" v-bind="tag" :lang="language.code"></tag-box>
            <tag-trail v-if="tag.type === 'trail'" :data-index="index" :key="`trail-${tag._id}`" v-bind="tag" :lang="language.code"></tag-trail>
          </template>
        </transition-group>
      </div>

      <interactive-slider
        v-if="interactiveSlides.length"
        :slides="interactiveSlides"
        :lang="language.code"
        :activeSlideId="activeInteractiveSlideId"
        @setActiveSlide="setActiveSlide"
      />

    </main-content>
  </div>
</template>
<script>
// import InteractiveSlider from '@/components/OldInteractiveSlider'
import EventBus from '@/store/event-bus'
import FeatureTags from '@/components/FeatureTags'
import InteractiveSlider from '@/components/InteractiveSlider'
import MainContent from '@/components/MainContent'
import TagBasic from '@/components/TagBasic'
import TagBox from '@/components/TagBox'
import TagRich from '@/components/TagRich'
import TagTrail from '@/components/TagTrail'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'interactive-tags',
  
  components: { FeatureTags, MainContent, TagBasic, TagBox, TagRich, TagTrail, InteractiveSlider},

  data () {
    return {
      activeInteractiveSlideId: null,
      activeRichTagId: null,
      animating: false,
      featureTags: [],
      slideTags: [],
      tags: [],
    }
  },

  watch: {
    activePage () {
      this.activeInteractiveSlideId = null
      this.setTags()
    },

    activeInteractiveSlide () {
      this.setSlideTags()
    }
  },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation',
      'isAnimating',
    ]),

    activeInteractiveSlide () {
      return _.find(this.interactiveSlides, slide => {
        return slide._id === this.activeInteractiveSlideId
      })
    },

    activeInteractiveSlideTags () {
      return this.activeInteractiveSlide ? _.sortBy(this.activeInteractiveSlide.tags, tag => { return tag.pos.x }) : []
    },

    backgroundImage () {
      if (this.activeInteractiveSlide && this.activeInteractiveSlide.backgroundImageOverride) {
        return this.activeInteractiveSlide.backgroundImageOverride
      } else {
        return this.activePage.backgroundImage
      }
    },

    filteredTags () {
      if (this.tags.length) {
        if (this.activeInteractiveSlideId) {
          return this.tags.filter(tag => tag.type !== 'rich')
        } else {
          return this.tags
        }
      } else {
        return []
      }
    },

    interactiveSlides () {
      return this.activePage.interactiveSlides ? this.activePage.interactiveSlides : []
    },

    sidebarNavigationItems () {
      let sidebarNavigationItems = []
      this.activeSubNavigation.forEach(_item => {
        let item = {
          to: `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
          label: _item.label,
          icon: _item.icon
        }
        sidebarNavigationItems.push(item)
      })
      return sidebarNavigationItems
    },

    sidebarNavigationKey () {
      return JSON.stringify(this.activeSubNavigation)
    },

    language () {
      return this.$store.getters.language
    }
  },

  mounted () {
    if (!this.activePage.interactiveSlideslength) {
      this.setTags()
    }
    this.setSlideTags()
    EventBus.$on('INTERACTIVE_SLIDES_ANIMATE_END', () => {
      this.setTags()
    })

    EventBus.$on('TAGS_ANIMATE_END', () => {
      console.log('set feature tags')
      this.setFeatureTags()
    })
  },

  methods: {
    enter (el, done) {
      setTimeout(() => {
        el.classList.remove('before-enter')
        el.classList.add('enter')
        // el.style.opacity = 1
        // el.style.transform = 'translateY(0)'
        // el.style.transition = `transform 0.6s, opacity 0.6s`
        done()
      }, (parseInt(el.dataset.index) + 1) * 300)
    },

    afterEnter (el) {
      el.classList.add('after-enter')
      if (parseInt(el.dataset.index) + 1 === this.tags.length) {
        setTimeout(() => {
          this.$store.commit('TAGS_ANIMATE_END')
        }, 600)
      }       
    },

    leave (el) {
      el.classList.remove('enter')
      el.classList.remove('after-enter')
      el.classList.add('leave')
    },

    deselectActiveSlide () {
      this.activeInteractiveSlideId = null
    },

    setActiveSlide (id) {
      this.activeInteractiveSlideId = id
      this.activeRichTagId = null
    },

    setSlideTags () {
      this.slideTags = []
      this.$nextTick(() => {
        if (this.activeInteractiveSlideTags) {
          this.slideTags = _.sortBy(this.activeInteractiveSlideTags, tag => { return tag.pos.x })
        } else {
          this.slideTags = []
        }
      })
    },

    setTags () {
      const normalTags = _.filter(this.activePage.tags, tag => {
        return tag.type !== 'feature'
      })

      this.tags = []
      this.$nextTick(() => {
        if (normalTags.length && !this.isAnimating) {
          console.log(this.tags)
          this.$store.commit('TAGS_ANIMATE_START')
          this.tags = _.filter(this.activePage.tags, tag => {
            return tag.type !== 'feature'
          })
          this.tags = _.sortBy(this.tags, tag => { 
            return tag.pos.x
          })
          console.log(this.tags)
        }

        if (!normalTags.length) {
          this.$store.commit('TAGS_ANIMATE_END')
        }
      })
    },

    setFeatureTags () {
      this.featureTags = _.filter(this.activePage.tags, tag => {
        return tag.type === 'feature'
      })
    },

    setActiveRichTagId (id) {
      if (this.activeRichTagId === id) {
        this.activeRichTagId = null
      } else {
        this.activeRichTagId = id
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.sidebar__spacer {
  flex-grow: 1;
  height: 100%;
}
.place {
  height: 100%;
  left: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  width: 100%;

  &__tag-slider-controls {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 3.75rem 0 6.25rem;

    div {
      transition: opacity 0.3s;

      &[aria-disabled=true] {
        opacity: 0.2;
      }
    }
  }

  &__tiny-slider {
    // display: flex;
  }

  &__tag-slider {
    background: rgba($lblue, 1);
    bottom: 0;
    position: absolute;
    width: 152rem;
    height: 23.25rem;
    padding: 2.35rem 8rem 2.4rem 9.8rem;

    .slide {
      display: flex;
      padding: 0 2rem;

      &--reverse {
        flex-direction: row-reverse;

        .slide__content {
          padding: 0 1rem 0 0;
        }
      }

      &__image-wrapper, &__content {
        position: relative;
        width: 50%;
      }

      &__image-reference {
        background-color: #000;
        border-radius: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.5em;
        font-size: 1.5rem;
        position: absolute;
        top: 0;
        left: 0;
        height: 3rem;
        width: 3rem;
      }

      &__content {
        padding-left: 1rem;
      }

      &__image {
        height: 18.5rem;
        object-fit: cover;
        width: 20rem;
      }

      &__heading {
        font-size: 1.5rem;
        font-weight: 400;
        margin-bottom: 0.5em;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }

      &__description {
        font-size: 1.5rem;
        font-weight: 200;
        line-height: 1.2;
        letter-spacing: 0.05em;
      }
    }

    &--vert {
     right: 0;
      height: 100%;
      padding: 14rem 2rem 8rem;
      width: 24rem;

      .place__tag-slider-controls {
        bottom: 0;
        height: 8rem;
        top: unset;
        padding: 0;
      }

      .place__tag-slider-prev, .place__tag-slider-next {
        padding: 2rem 5rem;
        transform: rotate(90deg);
      }

      .slide {
        display: block;
        padding: 0;

        &__image-wrapper, &__content {
          position: relative;
          width: 100%;
        }

        &__content {
          padding-bottom: 2rem;
          padding-left: 0rem;
        }

        &__image {
          height: 18.5rem;
          object-fit: cover;
          width: 20rem;
          padding-bottom: 1rem;
        }

        &__heading {
          font-size: 1.5rem;
          font-weight: 400;
          margin-bottom: 0.5em;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        &__description {
          font-size: 1.5rem;
          font-weight: 200;
          line-height: 1.2;
          letter-spacing: 0.05em;
        }
      }
    }    
  }

  &__heading {
    color: $lblue;
    font-size: 3.25rem;
    letter-spacing: 0.05em;
    line-height: 1.2;
    margin-bottom: 2rem;
    max-height: 13.2rem;
    position: relative;
    text-transform: uppercase;
    font-weight: 200;
  }

  &__description {
    font-size: 1.5rem;
    letter-spacing: 0.05em;
    line-height: 1.2;
    margin-bottom: 2em;
    max-height: 70rem;
    font-weight: 200;
  }  

  .sidebar__nav-item {
    transition: padding-left 0.3s;

    &.router-link-active, &--active {
      color: $bottombar-text-color-active;
    }
  }
}

@keyframes cloud {
  0% { 
    left: 0;
    transform: translateX(-100%) rotate(0deg);
  }
  50% {
    left: 100%;
    transform: rotate(45deg);
  }
  100% {
    left: 100%;
    transform: translateX(100%) rotate(0deg);
  }
}
</style>
